import React from 'react';
import {get} from 'lodash';
import {withStyles} from '@material-ui/core/styles';
import MobileStepper from '@material-ui/core/MobileStepper';
import Button from '@material-ui/core/Button';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import SwipeableViews from 'react-swipeable-views';
import {I18n} from 'react-redux-i18n';

const styles = {
  img: {
    width: '100%'
  }
};

class DVRSnapshotsStepper extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeChannel: -1,
      availableChannels: []
    };
  }

  componentWillReceiveProps(nextProps) {
    const {activeChannel} = nextProps;

    this.setState({activeChannel});
    this.setAvailableChannels(nextProps);
  }

  setAvailableChannels = props => {
    const availableChannels = props
      .channels
      .filter(channel => {
        if (this.props.machineType === 1) {
          return (channel.name === 'forwardFacing' || channel.name === 'rear');
        }
        return true;
      });
    this.setState({availableChannels});
  }

  getActiveChannel() {
    const {activeChannel} = this.state;

    if (activeChannel >= 0) {
      return activeChannel;
    }

    return get(this.props, 'activeChannel', 0);
  }

  handleNext = () => {
    const activeChannel = this.getActiveChannel();

    this.setState(prevState => ({
      activeChannel: activeChannel + 1
    }));
  };

  handleBack = () => {
    const activeChannel = this.getActiveChannel();

    this.setState(prevState => ({
      activeChannel: activeChannel - 1
    }));
  };

  handleChannelChange = activeChannel => {
    this.setState({activeChannel});
  };

  renderSnapshots = () => {
    const {classes} = this.props;
    const {availableChannels} = this.state;
    return availableChannels.map(channel => (
      <img
        key={channel.name}
        className={classes.img}
        src={channel.image}
        title={I18n.t(`page.dvrsnapshots.channels.${channel.name}`)}
        alt=""
      />
    ));
  }

  render() {
    const {classes, theme} = this.props;
    const {availableChannels} = this.state;
    const activeChannel = this.getActiveChannel();

    const maxChannels = availableChannels.length;
    return (
      <div className={classes.root}>
        <SwipeableViews
          axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
          index={activeChannel}
          onChangeIndex={this.handleChannelChange}
          enableMouseEvents
        >
          {this.renderSnapshots()}
        </SwipeableViews>

        <MobileStepper
          variant="text"
          steps={maxChannels}
          position="static"
          activeStep={activeChannel}
          className={classes.mobileStepper}
          nextButton={
            <Button size="small" onClick={this.handleNext} disabled={activeChannel === maxChannels - 1}>
              {I18n.t('defaults.next')}
              {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
            </Button>
          }
          backButton={
            <Button size="small" onClick={this.handleBack} disabled={activeChannel === 0}>
              {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
              {I18n.t('defaults.back')}
            </Button>
          }
        />
      </div>
    );
  }
}

export default withStyles(styles, {withTheme: true})(DVRSnapshotsStepper);
